import { Location } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';

import { fuseAnimations } from '@fuse/animations';

import { NoteService } from '../../../../shared/services/note.service';
import { INote, IParentEntity } from 'app/shared/interfaces/entity';
import { MatDialog } from '@angular/material/dialog';
import { NoteDialogComponent } from '../note-dialog/note-dialog.component';
import { Note } from 'app/shared/models/note';

@Component({
    selector: 'note-page',
    templateUrl: './note-page.component.html',
    styleUrls: ['./note-page.component.scss'],
    animations: fuseAnimations,
})
export class NotePageComponent implements OnInit, OnDestroy {
    baseUrl: string;
    notes: INote[];
    currentNote: INote;
    _parent: IParentEntity;

    onChanged: Subscription;
    onCurrentNoteChanged: Subscription;

    @Input() inWidget: boolean;
    @Input() readOnly = false;

    @Input() set parent(val: IParentEntity) {

        this._parent = val;
        this.baseUrl = `notes/${this._parent.type}/${this._parent.uid}`;

        // get the notes based on parent and type - in this case we are fecthing all but...
        // TODO: this may need review at a later date to limit number of notes returned
        this.noteService.getNotesByType(this._parent, 'all');
    }

    constructor(
        public dialog: MatDialog,
        private route: ActivatedRoute,
        private noteService: NoteService,
        private router: Router,
        private location: Location,
    ) { }

    ngOnInit() {
        // Subscribe to update notes on changes
        this.onChanged =
            this.noteService.onNotesChanged
                .subscribe((notes) => {
                    this.notes = [...notes];
                    this.notes = this.noteService.ApplyNoteTypeFilter(this.notes);
                    // console.log('Notes:', this.notes);
                });

        // Subscribe to update current note on changes
        this.onCurrentNoteChanged =
            this.noteService.onCurrentNoteChanged
                .subscribe((currentNote) => {
                    if (!currentNote) {
                        // Set the current note id to null to deselect the current note
                        this.currentNote = null;
                        // handle the location change
                        this.goLocation();
                    }
                    else {
                        this.currentNote = currentNote;
                    }
                });
    }

    ngOnDestroy() {
      if (this.onChanged) this.onChanged.unsubscribe();
      if (this.onCurrentNoteChanged) this.onCurrentNoteChanged.unsubscribe();
    }

    /**
     * Read note - if inside widget then this will navigate to notes - if not in widget will set note to be read
     * @param id
     */
    readNote(note: INote) {
        if (!this.inWidget) {
            this.goLocation(note.uid);
            this.noteService.setCurrentNote(note.uid);
        }
        else {
            this.noteService.setCurrentNote(note.uid);
            note.note = new Note(note.note);
            this.dialog.open(NoteDialogComponent, {
                data: {
                    note,
                    parent: this._parent,
                    readOnly: (note.sequenceId || note.readOnly || this.readOnly) ? true : false,
                },
                disableClose: true,
                autoFocus: false,
            });

            // this.noteService.setCurrentNote(note.uid);
            // // TODO:  Should we be using all or should we be filtering by a different type?
            // this.router.navigateByUrl(`${this.baseUrl}/notetype/all`);
        }
    }

    goLocation(uid?: string) {
        const filterHandle = this.route.snapshot.params.filterHandle;
        const noteTypeHandle = this.route.snapshot.params.noteTypeHandle;
        const noteId = (uid) ? '/' + uid : '';
        if (filterHandle) {
            this.location.go(`${this.baseUrl}/filter/` + filterHandle + noteId);
        }
        else {
            this.location.go(`${this.baseUrl}/notetype/` + noteTypeHandle + noteId);
        }
    }

    printNote(note: INote) {
        this.noteService.print(this._parent, [note]);
    }

    trackByFn(index, item) {
        return item.id;
    }
}
